/** Page /reset-password?token=XXX — étape 2 : choisir un nouveau mot de passe. */

import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { authApi } from '../services/api';

export function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') ?? '';

  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  if (!token) {
    return (
      <div className="min-h-screen bg-canvas flex items-center justify-center p-4">
        <div className="bg-white p-6 rounded-xl border border-stone-200 shadow-soft max-w-sm w-full text-center">
          <p className="text-sm text-rose-700">Lien invalide — jeton manquant.</p>
          <Link to="/login" className="text-sm text-accent hover:underline mt-3 inline-block">
            Retour à la connexion
          </Link>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (next.length < 8) return setError('Mot de passe trop court (8 caractères minimum)');
    if (next !== confirm) return setError('Les deux mots de passe ne correspondent pas');
    setLoading(true);
    try {
      await authApi.confirmPasswordReset(token, next);
      setSuccess(true);
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erreur');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-canvas flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-ink">PointBreak</h1>
          <p className="text-sm text-stone-500 mt-1">Nouveau mot de passe</p>
        </div>

        {success ? (
          <div className="bg-white p-6 rounded-xl border border-stone-200 shadow-soft text-center space-y-3">
            <div className="w-12 h-12 mx-auto rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12" />
              </svg>
            </div>
            <p className="text-sm text-ink font-medium">Mot de passe mis à jour</p>
            <p className="text-xs text-stone-500">Redirection vers la page de connexion…</p>
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            className="bg-white p-6 rounded-xl border border-stone-200 shadow-soft space-y-4"
          >
            <Input
              label="Nouveau mot de passe (min. 8 caractères)"
              type="password"
              value={next}
              onChange={(e) => setNext(e.target.value)}
              autoComplete="new-password"
              autoFocus
              required
            />
            <Input
              label="Confirmer le nouveau mot de passe"
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              autoComplete="new-password"
              required
            />
            {error && (
              <div className="text-xs bg-red-50 border border-red-200 text-red-700 rounded-md p-2">
                {error}
              </div>
            )}
            <Button type="submit" loading={loading} className="w-full">
              Mettre à jour le mot de passe
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
